<template>
    <svg xmlns="http://www.w3.org/2000/svg" data-name="Livello 1" viewBox="0 0 24 24" fill="currentColor"><path d="M19.48 2.06H6.86c-1.61 0-2.92 1.31-2.92 2.92v14.03c0 1.61 1.31 2.92 2.92 2.92h12.63c.32 0 .58-.26.58-.58V2.65a.58.58 0 0 0-.58-.58ZM6.86 3.23H18.9v12.86H6.86c-.66 0-1.26.22-1.75.59V4.99c0-.97.79-1.75 1.75-1.75Zm0 17.54c-.97 0-1.75-.79-1.75-1.75s.79-1.75 1.75-1.75H18.9v3.51H6.86Z" /></svg>
</template>

